import React, { useEffect, useState, useCallback } from 'react';
import { adminApi } from '../../services/api';
import { exportXlsx } from './exportXlsx';

const todayStr = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d.toISOString().slice(0, 10); };
const fmtDay = (d: string) => (d ? new Date(d).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) : '-');

export const AdminExternallyPaidScreen: React.FC = () => {
  const [from, setFrom] = useState(todayStr());
  const [to, setTo] = useState(todayStr());
  const [rows, setRows] = useState<any[]>([]);
  const [grandTotal, setGrandTotal] = useState(0);

  const load = useCallback(async () => {
    const res = await adminApi.externallyPaid({ from: `${from}T00:00:00.000Z`, to: `${to}T23:59:59.999Z` });
    setRows(res.data);
    setGrandTotal(res.grandTotal || 0);
  }, [from, to]);

  useEffect(() => { load(); }, [load]);

  const exportRows = () => {
    const flat = rows.map((r) => ({
      User: r.userName || (r.externalRef ? `Unknown ref: ${r.externalRef}` : ''),
      Phone: r.userPhone || '',
      'Order #': r.orderNumber,
      'Order Amount': Number(r.totalAmount ?? 0),
      'Paid Amount': Number(r.externallyPaidAmount ?? 0),
      'Paid Date': r.externallyPaidAt ? fmtDay(r.externallyPaidAt) : '',
      'Marked By': r.externallyPaidBy || '',
    }));
    exportXlsx(`externally-paid_${from}_${to}.xlsx`, 'Externally Paid', flat);
  };

  return (
    <div>
      <div className="admin-filters">
        <label>From<input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></label>
        <label>To<input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></label>
        <button className="admin-btn allocate" onClick={exportRows} disabled={rows.length === 0}>
          <i className="fas fa-file-excel"></i> Export to Excel
        </button>
      </div>
      <p className="admin-muted">Grand total externally paid: <strong>R {grandTotal.toFixed(2)}</strong> · {rows.length} order(s)</p>
      <table className="admin-table">
        <thead>
          <tr><th>User</th><th>Order #</th><th>Order Amount</th><th>Paid Amount</th><th>Paid Date</th><th>Marked By</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.userName || (r.externalRef ? `Unknown ref: ${r.externalRef}` : '-')}{r.userPhone ? <span className="admin-muted"> · {r.userPhone}</span> : null}</td>
              <td>{r.orderNumber}</td>
              <td>R {Number(r.totalAmount ?? 0).toFixed(2)}</td>
              <td>R {Number(r.externallyPaidAmount ?? 0).toFixed(2)}</td>
              <td>{fmtDay(r.externallyPaidAt)}</td>
              <td>{r.externallyPaidBy || '-'}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={6} className="admin-muted">No externally-paid orders in this range.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
